import{dew}from"js/dist/alert.js";export default dew();